export var dataKey = 'text';export var dataKey = 'text';